module.exports = __webpack_public_path__ + "static/media/ie.ce6c7d81.svg";